import { getAmplitudeInstance } from '../amplitudeHelpers';
import SignUpScreenContinueButtonType from '../enums/SignUpScreenContinueButtonType';

type logLogInScreenContinueButtonTappedParams = {
  login_screen_continue_button_type?: SignUpScreenContinueButtonType;
};

/**
 * The user taps one of the ‘Continue' buttons to sign in (i.e. 'Continue with Google'), or taps the 'Log In’ CTA after entering in their credentials.
 * @param params - Attributes to log with the amplitude event
 * @param params.login_screen_continue_button_type - The type of sign in the user taps from the Log In Screen
 */
const logLogInScreenContinueButtonTapped = (
  { login_screen_continue_button_type }: logLogInScreenContinueButtonTappedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'log in screen continue button tapped',
    { 'login screen continue button type': login_screen_continue_button_type },
    callback
  );
};

export default logLogInScreenContinueButtonTapped;
